import { render } from "./NfcAssigmentModal.vue?vue&type=template&id=dfa8d666"
import script from "./NfcAssigmentModal.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./NfcAssigmentModal.vue?vue&type=script&charset=utf-8&lang=js"

import "./NfcAssigmentModal.vue?vue&type=style&index=0&id=dfa8d666&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__